import React from 'react';
import { Link } from 'react-router-dom';
import './Anchor.scss';

import SVG from 'react-svg';

import { IAnchor } from 'src/app/interfaces';

import CopyToClipboard from 'react-copy-to-clipboard';
import linkIcon from 'src/assets/svg/link.svg';

const Anchor = ({ hash }: IAnchor) => {
    const location = window.location.href.split('#')[0];
    return (
        <span id={hash} className='AMB-Anchor'>
            <CopyToClipboard text={`${location}#${hash}`}>
                <SVG className='link' src={linkIcon} wrapper='span' />
            </CopyToClipboard>
        </span>
    );
};

export default Anchor;
